var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackarrowMbBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.816,
    height: 11.926,
    viewBox: "0 0 21.816 11.926",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "backarrow",
    transform: "translate(-0.269 -292.234)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path9417",
    d: "M6.2,292.235a.992.992,0,0,0-.682.3L.558,297.5a.992.992,0,0,0,0,1.4l4.96,4.968a1,1,0,1,0,1.407-1.407l-3.266-3.266H21.092a.993.993,0,0,0,0-1.987H3.651l3.274-3.266a.992.992,0,0,0-.725-1.708Z",
    transform: "translate(0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackarrowMbBlack);
export default __webpack_public_path__ + "static/media/backarrow-mb_black.9c33649292ceb9bab9e1e0c91f7dc196.svg";
export { ForwardRef as ReactComponent };